import { utils } from '@febos-io/common';

export function schema(isNewPasswordRequired) {
  return utils.validator.object().shape({
    email: utils.validator.string()
      .required('This field is required')
      .email('This field is invalid'),
    password: utils.validator.string().required('This field is required'),
    ...(isNewPasswordRequired && {
      newPassword: utils.validator.string()
        .required('This field is required')
        .passwordMatch('The passwords do not match')
    })
  });
}

export default schema;
